import React, { useState } from "react";
import { motion, useScroll, useMotionValueEvent } from "framer-motion";
import { Menu, X } from "lucide-react";

const DynamicNavbar = ({ onOpenModal }) => {
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { scrollY } = useScroll();

  useMotionValueEvent(scrollY, "change", (latest) => {
    if (latest < 100) {
      setIsVisible(true);
    } else if (latest > lastScrollY) {
      setIsVisible(false);
    } else {
      setIsVisible(true);
    }
    setLastScrollY(latest);
  });

  return (
    <motion.nav
      className="fixed top-0 w-full z-50 border-b border-black/5"
      style={{ backdropFilter: "blur(25px)", backgroundColor: "rgba(255,255,255,0.8)" }}
      initial={{ y: 0 }}
      animate={{ y: isVisible ? 0 : -100 }}
      transition={{ duration: 0.3, ease: [0.25, 0.1, 0.25, 1] }}
      data-testid="dynamic-navbar"
    >
      <div className="px-4 sm:px-6 md:px-10 xl:px-16 flex justify-between items-center w-full h-[64px] sm:h-[72px] md:h-[80px]">
        {/* Left — Logo */}
        <motion.a
          href="/"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          style={{ cursor: "pointer" }}
          data-testid="navbar-logo"
        >
          <img
            src="/Logo.svg"
            alt="MyBovine.ai"
            className="h-[30px] sm:h-[36px] md:h-[44px] w-auto"
          />
        </motion.a>

        {/* Right — CTA + Mobile toggle */}
        <div className="flex items-center gap-4">
          <motion.button
            onClick={onOpenModal}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="hidden sm:flex items-center justify-center text-[16px] font-medium bg-[#00BD7E] text-white px-[16px] py-[12px] rounded-[8px] hover:bg-[#00a86b] transition-colors"
            style={{ fontFamily: "Satoshi, sans-serif" }}
            data-testid="navbar-cta-btn"
          >
            Book a Farm Assessment
          </motion.button>

          {/* Mobile menu toggle */}
          <motion.button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            className="sm:hidden p-2"
            data-testid="mobile-menu-btn"
            aria-label="Toggle menu"
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </motion.button>
        </div>
      </div>

      {/* Mobile dropdown */}
      {isMobileMenuOpen && (
        <motion.div
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: "auto" }}
          exit={{ opacity: 0, height: 0 }}
          className="sm:hidden border-t border-black/5"
          style={{ backgroundColor: "rgba(255,255,255,0.95)", backdropFilter: "blur(25px)" }}
        >
          <div className="px-4 py-4">
            <motion.button
              onClick={() => {
                onOpenModal();
                setIsMobileMenuOpen(false);
              }}
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              className="text-[16px] font-medium bg-[#00BD7E] text-white px-[16px] py-[12px] rounded-[8px] hover:bg-[#00a86b] transition-colors w-full"
              style={{ fontFamily: "Satoshi, sans-serif" }}
            >
              Book a Farm Assessment
            </motion.button>
          </div>
        </motion.div>
      )}
    </motion.nav>
  );
};

export default DynamicNavbar;
